import { z } from "zod";
import { TObjectBase } from "../../base";
import { TFirebaseTimestamp } from "../../deprecated";

export type IRawIntegrationMapping = z.infer<typeof TRawIntegrationMapping>;
export const TRawIntegrationMapping = z
  .object({
    internalID: z.string().optional(),
    externalID: z.string(),
    dataType: z.string(),
    state: z.string(),
  })
  .extend(TObjectBase.shape);

export type IRawCompanyIntegrationBaseSettings = z.infer<
  typeof TRawCompanyIntegrationBaseSettings
>;
export const TRawCompanyIntegrationBaseSettings = z.object({
  lastManualPropertiesUpdate: TFirebaseTimestamp.optional(),
  lastManualPropertiesUpdateUser: z.string().optional(),
});

export type IRawCompanyIntegration = z.infer<typeof TRawCompanyIntegration>;
export const TRawCompanyIntegration = z
  .object({
    apiClientID: z.string(),
    properties: z.array(z.string()).optional(),
    scopes: z.array(z.string()).optional(),
  })
  .extend(TObjectBase.shape);
